import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HotelsPage() {
  return <div className="min-h-screen bg-white flex items-center justify-center" data-id="element-501">
      <div className="container mx-auto px-4 md:px-6 lg:px-12 py-20" data-id="element-502">
        <div className="max-w-3xl mx-auto text-center" data-id="element-503">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-12 transition-colors" data-id="element-504">
            <ArrowLeftIcon size={16} data-id="element-505" />
            Back to Home
          </Link>

          <h1 className="text-5xl md:text-7xl font-light mb-6 text-gray-900" data-id="element-506">
            Hotels
          </h1>

          <div className="mb-12" data-id="element-507">
            <p className="text-2xl md:text-3xl font-light text-gray-600 mb-4" data-id="element-508">
              Coming Soon
            </p>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto" data-id="element-509">
              We're crafting something special for luxury hotels. Stay tuned for
              premium hydration solutions designed for discerning guests.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-510">
            <a href="https://form.typeform.com/to/rfYM00cT" target="_blank" rel="noopener noreferrer" className="px-10 py-4 bg-gray-900 text-white text-base font-medium rounded-full hover:bg-gray-800 transition-colors" data-id="element-511">
              Request a Demo
            </a>
            <a href="https://calendly.com/-smartsoda/discoverycall" target="_blank" rel="noopener noreferrer" className="px-10 py-4 border-2 border-gray-900 text-gray-900 text-base font-medium rounded-full hover:bg-gray-900 hover:text-white transition-colors" data-id="element-512">
              Talk to Our Team
            </a>
          </div>
        </div>
      </div>
    </div>;
}